import { Switch } from "@mui/material";

import { customNameComparator } from "../../../../helpers/coappDataGridUtils";
import CoAppDataGridDateTimeCell from "../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridListCell from "../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import ThreeDotMenu from "../../../global/components/ThreeDotMenu";

export const userColumns = ["actions", "user", "status", "roles", "groups", "lastHeartbeat", "createdAt", "workstationId"];

export const getUserManagementColumns = (
	viewUserPageFromUserManagement,
	handleOpenUserDeletionDialog,
	handleUserStatusToggle,
	organizationSsoStatus,
	loading,
	handleWorkstationClick
) => [
	{
		field: "user",
		headerName: "Name",
		sortable: true,
		sortComparator: customNameComparator,
		valueGetter: (params) => params.value === "" ? "" : params,
		editable: false,
		width: 200,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellValue={params.value}
				cellToRender={
					<CoAppDataGridNameCell item={params.row} isUser={true} isCoAppSupport={params.row.isCoAppSupport} />
				}
			/>
		),
	},
	{
		field: "roles",
		headerName: "Roles",
		sortable: false,
		editable: true,
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridListCell items={params.value} resource="Roles" isCoAppSupport={params.row.isCoAppSupport} />
				}
				isLoading={loading}
			/>
		),
	},
	{
		field: "groups",
		headerName: "Groups",
		editable: false,
		sortable: false,
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridListCell items={params.value} resource="Groups" isCoAppSupport={params.row.isCoAppSupport} />
				}
				isLoading={loading}
			/>
		),
	},
	{
		field: "lastHeartbeat",
		headerName: "Last heartbeat",
		editable: false,
		sortable: true,
		width: 200,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridDateTimeCell value={params.value} isCoAppSupport={params.row.isCoAppSupport} />
				}
				isLoading={loading}
			/>
		),
	},
	{
		field: "createdAt",
		headerName: "Created",
		sortable: true,
		editable: false,
		width: 200,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridDateTimeCell value={params.value} isCoAppSupport={params.row.isCoAppSupport} />
				}
				isLoading={loading}
			/>
		),
	},
	{
		field: "workstationId",
		headerName: "Workstation ID",
		editable: false,
		sortable: false,
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<div
						style={{ cursor: params.value ? "pointer" : "default" }}
						onClick={() => handleWorkstationClick(params.value)}
					>
						<CoAppDataGridNameCell item={{ name: params.value }} />
					</div>
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "active",
		headerName: "Status",
		sortable: true,
		editable: false,
		width: 90,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<Switch
						checked={params.row.active}
						disabled={organizationSsoStatus || params.row.isCoAppSupport}
						onChange={() => handleUserStatusToggle(params.row.id, params.row.active === true ? "false" : "true")}
					/>
				}
				isLoading={loading}
			/>
		),
	},
	{
		field: "actions",
		type: "actions",
		flex: .1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<div>
						{
							organizationSsoStatus ?
								<ThreeDotMenu
									options={[
										{
											name: "View User",
											optionClickHandler: () => {
												viewUserPageFromUserManagement(params);
											},
										},
									]}
									isCoAppSupport={params.row.isCoAppSupport}
								/>
								:
								<ThreeDotMenu
									options={
										[
											{
												name: "Edit",
												optionClickHandler: () => {
													viewUserPageFromUserManagement(params);
												},
											},
											{
												name: "Delete",
												optionClickHandler: () => {
													handleOpenUserDeletionDialog({ params });
												},
											},
										]
									}
									isCoAppSupport={params.row.isCoAppSupport}
								/>
						}
					</div>
				}
				isLoading={loading}
			/>
		)
	}
];